import { createApiSlice } from "@common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CRUD_EMPLOYMENT_MAIN_FETCH_BY_ID, CRUD_EMPLOYMENT_MAIN, HCM_PERSONAL_DOWNLOAD_DATA , HCM_PERSONAL_UPLOAD_DATA } from "@routes";
import axios from "axios";
// Define the API config array
const apiConfig = [
  {
    name: "addEmploymentMain",
    method: "post",
    url: CRUD_EMPLOYMENT_MAIN,
    stateKey: "message",
  },
  {
    name: "getEmploymentMain",
    method: "get",
    url: CRUD_EMPLOYMENT_MAIN,
    stateKey: "data",
  },
  {
    name: "updateEmploymentMain",
    method: "put",
    url: CRUD_EMPLOYMENT_MAIN,
    stateKey: "message",
  },
  {
    name: "deleteEmploymentMain",
    method: "delete",
    url: CRUD_EMPLOYMENT_MAIN,
    stateKey: "message",
  },
  {
    name: "getEmploymentMainDetailsById",
    method: "get",
    url:CRUD_EMPLOYMENT_MAIN_FETCH_BY_ID,
    stateKey: "details",
  },
  // {
  //   name: "uploadEmploymentMainFile",
  //   method: "post",
  //   url: HCM_PERSONAL_UPLOAD_DATA,
  //   stateKey: "message",
  // },
];
export const uploadEmploymentMainFile = createAsyncThunk(
  "prospect/uploadEmploymentMainFile",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(HCM_PERSONAL_UPLOAD_DATA, formData, {
        withCredentials: true,
        responseType: "blob",
      });

      const contentType = res.headers["content-type"];

      // Backend returned failed Excel
      if (
        contentType?.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        const url = globalThis.URL.createObjectURL(
          new Blob([res.data])
        );

        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "FailedEmploymentMains.xlsx");

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        globalThis.URL.revokeObjectURL(url);

        return {
          message: "Some prospects failed. Failed records have been downloaded.",
        };
      }

      // Backend returned JSON response
      const text = await res.data.text();
      const data = JSON.parse(text);

      return data;
    } catch (err) {
      let errorData = err?.response?.data;

      // Error response can also be a Blob
      if (errorData instanceof Blob) {
        try {
          const text = await errorData.text();
          errorData = JSON.parse(text);
        } catch {
          // Keep original errorData if it is not JSON
        }
      }

      return rejectWithValue(errorData);
    }
  }
);
export const downloadEmploymentMainData = createAsyncThunk(
  "prospect/downloadEmploymentMainData",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      console.log("Downloading prospect data with params:", data);
      await axios
        .get(HCM_PERSONAL_DOWNLOAD_DATA , {
          params: data,
          withCredentials: true,
          responseType: "blob",
        })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute("download", "EmploymentMains.xlsx");

          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);
// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    [downloadEmploymentMainData.pending]: (state) => {
      state.loading = true;
    },

    [downloadEmploymentMainData.fulfilled]: (state) => {
      state.loading = false;
    },

    [downloadEmploymentMainData.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [uploadEmploymentMainFile.pending]: (state) => {
      state.loading = true;
    },

    [uploadEmploymentMainFile.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },

    [uploadEmploymentMainFile.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage =
        action?.payload?.message ||
        action?.payload?.data?.message;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "prospect",
  apiConfig,
  customReducers,
);
const prospectSlice = slice;

// Export the slice's reducer
export default prospectSlice.reducer;

// Export thunks
export const {
  addEmploymentMain,
  getEmploymentMain,
  updateEmploymentMain,
  deleteEmploymentMain,
  getEmploymentMainDetailsById,

  // uploadEmploymentMainFile
} = thunks;

// Export actions
export const { rowSelect } = actions;
